export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
    visible: that.multiple
  },
  {
    field: 'radio',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'radio',
    visible: !that.multiple
  },
  {
    title: that.$l('INDEX.form_label_mrpOutsourcingNo') || '委外加工订单编号',
    field: 'mrpOutsourcingOrderNo',
    headerAlign: 'center',
    minWidth: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_materialNo') || '物料编号',
    field: 'materialNo',
    headerAlign: 'center',
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_materialName') || '物料名称',
    field: 'materialName',
    headerAlign: 'center',
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_materialType') || '物料类型',
    field: 'v_materialType',
    headerAlign: 'center',
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_materialSpec') || '物料规格',
    field: 'materialSpec',
    headerAlign: 'center',
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_materialBatchUnit') || '物料单位',
    field: 'materialUnit',
    headerAlign: 'center',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_materialBatchDisplayName') || '物料显示名称',
    field: 'materialDisplayName',
    headerAlign: 'center',
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_ncMaterialNo') || 'NC物料编码',
    field: 'ncMaterialNo',
    headerAlign: 'center',
    minWidth: 130,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_order_no') || '订单编号',
    field: 'orderNo',
    headerAlign: 'center',
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_production_order_scm_name') || '供应商名称',
    field: 'scmName',
    headerAlign: 'center',
    minWidth: 160,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.quantity') || '数量',
    field: 'quantity',
    headerAlign: 'center',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_taxRate') || '税率',
    field: 'taxRate',
    headerAlign: 'center',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_unitPriceTaxIncluded') || '含税单价',
    field: 'unitPriceTaxIncluded',
    headerAlign: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_unitPrice') || '不含税单价',
    field: 'unitPrice',
    headerAlign: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_aoumntTaxIncluded') || '含税金额',
    field: 'aoumntTaxIncluded',
    headerAlign: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_aoumnt') || '不含税金额',
    field: 'aoumnt',
    headerAlign: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
